import { Flex, Tag } from 'antd';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';

export const ClientsTagsSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeClientsTags } = useNewClientsListContext();
  const { clientsTags, isIncludeClientsTags } = filtersMap.get(id)!;

  if (clientsTags.length === 0) {
    return null;
  }

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      {clientsTags.length > 0 && (
        <Tag
          key={isIncludeClientsTags ? 'include' : 'exclude'}
          className={`${PF}__tag`}
          closable
          onClose={() => onChangeClientsTags([], id)}
        >
          {isIncludeClientsTags ? 'Включено' : 'Исключено'}:{' '}
          {clientsTags.length} тег
          {clientsTags.length === 2 ||
          clientsTags.length === 3 ||
          clientsTags.length === 4
            ? 'а'
            : clientsTags.length > 4
            ? 'ов'
            : ''}
        </Tag>
      )}
    </Flex>
  );
};
